<template>
  <v-container fluid>    
    <v-card 
      class="mx-auto"
      style="margin-bottom: 10px;"
      outlined
    >
      <v-container fluid>
        <div class="chip_box2">
          <v-btn
            color="#78909C"
            style="margin:10px 10px 10px 10px;"
            outlined
            @click="date = [] , search ='', [initialize(), refresh()]"
          >
            <div v-if="runProgress" style="display:flex;justify-content: flex-start;">
              <div id="progress-bar-container">
                <span id="progress-bar" />
              </div>
              <span style="margin-left:10px; display : flex;justify-content : center;align-items : center;">Refresh</span>
            </div>
            <div v-else style="display:flex;align-items:center;">
              <v-icon>
                mdi-restore
              </v-icon>
              <span style="margin-left:5px;">Refresh</span>
            </div>
          </v-btn>
          <div
            style="display:flex;width:450px;margin:-11px 20px -20px 20px;"
          >
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              z-index="100"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateFrom"
                  class="pt-6"
                  style="margin-left:30px;width:108px;"
                  label="Start (from)"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  width="100"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="dateFrom"
                @input="menu = false"
              />
            </v-menu>
            <v-icon style="padding-left:5px;">
              mdi-tilde
            </v-icon>
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              z-index="100"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateTo"
                  style="margin-left:10px;width:108px;"
                  class="pt-6"
                  label="Start (to)"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="dateTo"
                @input="menu2 = false"
              />
            </v-menu>  
          </div>
          <v-text-field
            v-model="search"
            style="margin:4px -20px 0px 10px;"
            prepend-icon="mdi-database-search"
            class="mx-4"
            flat
            hide-details
            label="Analysis Name"
            solo-inverted
            @keyup.enter="initialize()"
          />
          
          <div style="margin:0px 0px 0px 0px;">
            <v-btn
              color="#78909C"
              style="margin:10px 0px 10px 10px;"
              outlined
              @click="dateFrom = resetFrom, dateTo = resetTo, search = '', selectItem = 'All', initialize()"
            >
              <v-icon>
                mdi-restore
              </v-icon>
              <span style="margin-left:5px;">Reset</span>
            </v-btn>
            <v-btn
              color="#78909C"
              style="margin:10px 7px 10px 10px;"
              outlined
              :loading="progress" 
              :disabled="progress"
              @click="initialize()"
            >
              <v-icon>
                mdi-magnify
              </v-icon>
              <span style="margin-left:5px;">Search</span>
            </v-btn>
            <v-btn
              color="#78909C"
              style="margin:10px 7px 10px 10px;"
              outlined
              @click="eventHandler('delete')"
            >
              <v-icon>
                mdi-delete
              </v-icon>
              <span style="margin-left:5px;">Delete</span>
            </v-btn>
          </div>
        </div>
      </v-container>
    </v-card>
    <v-card 
      v-show="level == 1"
      class="mx-auto"
      style="margin-bottom: 10px;"
      outlined
    >
      <v-container fluid>
        <div 
          class="chip_box" 
          :class="{ on: level !== 1 }"
        >
          <v-autocomplete
            v-show="level == 1"
            v-model="selectItem"
            class="select_box"
            :items="selectItems"
            item-text="name"
            item-value="value"
            label="Client ID"
            append-icon="mdi-magnify"
            clearable
            dense
            outlined
            @click="searchWord = ''"
          />
        </div>
      </v-container>
    </v-card>
    <v-card
      outlined
      :height="levelHeight"
    >
      <v-card-text>
        <v-progress-linear
          indeterminate
          color="#78909C"
          :active="progress"
        />
        <!-- 여기가 본문 grid -->
        <grid
          :key="componentKey2"
          ref="grid2"
          :data="gridProps2.data"
          :columns="gridProps2.columns"
          :options="gridProps2.options"
          :columnOptions="gridProps2.columnOptions"
          :pageOptions="gridProps2.pageOptions"
          :bodyHeight="gridProps2.bodyHeight"
          :header="gridProps2.header"
          :theme="gridProps2.myTheme"
          @click="onClickResult"
        />
      </v-card-text>
    </v-card>
    <v-row>
      <v-snackbar
        v-model="snackBar"
      >
        {{ snackBarMessage }}
        <template v-slot:action="{ attrs }">
          <v-btn
            color="pink"
            text
            v-bind="attrs"
            @click="snackBar = false"
          >
            CLOSE
          </v-btn>
        </template>
      </v-snackbar>
      <v-dialog
        v-model="dialog"
        overlay-opacity="0"
        scrollable
        max-width="1200px"
      >
        <v-card 
          tile
          max-height="800px"
        >
          <v-toolbar
            flat
            dark
            color="#78909C"
          >
            <span 
              v-show="taskInfo.progress !== 100" 
              id="progress-bar-container" 
              style="margin-right:10px;"
            >
              <span id="progress-bar" />
            </span>
            <v-icon 
              v-show="taskInfo.progress == 100"
              size="35"
              style="margin-right:8px;"
            >
              mdi-check
            </v-icon>
            <v-toolbar-title>Task Information</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-btn
                icon
                dark
                @click="dialog = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
            <v-menu
              bottom
              right
              offset-y
            />
          </v-toolbar>
          <v-card-text>
            <v-col cols="12">
              <v-list
                two-line
                subheader
              >              
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title style="font-size: 1.4rem;font-weight: 500;">
                      {{ taskInfo.name }} 
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider />
              </v-list>
            </v-col>
            <v-row>
              <v-col
                class="nothing"
                :cols="12" 
                :md="md_out"
                :class="{ on: transitioning }"
              >
                <v-row>
                  <v-col :cols="cols_in">
                    <v-card 
                      class="text-center" 
                      height="100%" 
                      outlined
                    >
                      <v-card-text>
                        <div class="text-h6 mb-2">
                          {{ taskInfo.targetRegion }}
                        </div>
                        Target Region
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col :cols="cols_in">
                    <v-card 
                      class="text-center" 
                      height="100%" 
                      outlined
                    >
                      <v-card-text>
                        <div class="text-h6 mb-2">
                          {{ taskInfo.variableRegion }}
                        </div>
                        Variable Region
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col :cols="cols_in">
                    <v-card 
                      class="text-center" 
                      height="100%" 
                      outlined
                    >
                      <v-card-text>
                        <div class="text-h6 mb-2">
                          {{ taskInfo.database }}
                        </div>
                        Database
                      </v-card-text>
                    </v-card>
                  </v-col>
                  
                  <v-col :cols="cols_in">
                    <v-card 
                      class="text-center" 
                      height="100%" 
                      outlined
                    >
                      <v-card-text>
                        <div class="text-h6 mb-2">
                          {{ taskInfo.group }}
                        </div>
                        Group
                      </v-card-text>
                    </v-card>
                  </v-col>
  
                  <v-col :cols="cols_in">
                    <v-card 
                      class="text-center" 
                      height="100%" 
                      outlined
                    >
                      <v-card-text>
                        <div class="text-h6 mb-2">
                          {{ processingDepth(taskInfo.mnd) }}
                        </div>
                        Minimum depth of samples
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col :cols="cols_in">
                    <v-card 
                      class="text-center" 
                      height="100%" 
                      outlined
                    >
                      <v-card-text>
                        <div class="text-h6 mb-2">
                          {{ processingDepth(taskInfo.mxd) }}
                        </div>
                        Maximum depth of samples
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
              <v-col 
                class="nothing"
                col="6" 
                :md="md_out"
                :class="{ on: transitioning }"
              >
                <v-card-title class="color: blue-grey lighten-1 white--text" style="display:flex;justify-content: space-between;">
                  {{ taskInfo.sampleCount }} Sample(s) Info
                  <v-icon v-if="!wide" style="color:white" @click="wideSwitch(wide)">mdi-arrow-expand</v-icon>
                  <v-icon v-else style="color:white" @click="wideSwitch(wide)">mdi-arrow-collapse</v-icon>
                </v-card-title>
                <div 
                  style="border-left:1px solid #E0E0E0;margin:0px 0.2px;"
                >
                  <grid
                    ref="grid"
                    :key="componentKey"
                    :data="gridProps.data"
                    :columns="gridProps.columns"
                    :options="gridProps.options"
                    :columnOptions="gridProps.columnOptions"
                    :bodyHeight="gridProps.bodyHeight"
                    :header="gridProps.header"
                    @click="onClickInfo"
                  />
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <div style="flex: 1 1 auto;" />
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="deleteDialog"
        :max-width="450"
        @keydown.enter="removeResult()"
      >
        <v-card>
          <v-toolbar
            flat
            dark
            color="#78909C"
            dense
            style="height:40px;"
          >
            Message
          </v-toolbar>
          <v-sheet class="px-12 pt-7 pb-4 mx-auto text-center">
            <div class="text-body-2 mb-4">
              The below <b>{{ selected.length }}</b> results will be deleted.
            </div>
            <div
              v-for="(child, i) of selected"
              :key="i"
              style="margin-bottom:0px;"
            >
              <span style="display: block;font-size:15px;"><p>{{ child._attributes.rowNum }}. {{ child.analysisName }}</p></span>              
            </div>
            <v-btn
              class="ma-1"
              color="error"
              plain
              @click="deleteDialog = false"
            >
              Cancel
            </v-btn>
            <v-btn
              class="ma-1"
              color="primary"
              plain
              @click="removeResult()"
            >
              OK
            </v-btn>
          </v-sheet>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="generateDialog"
        :max-width="350"
        @keydown.enter="generateAcademicReport(academicInfo)"
      >
        <v-card>
          <v-toolbar
            flat
            dark
            color="#78909C"
            dense
            style="height:40px;"
          >
            Message
          </v-toolbar>
          <v-sheet class="px-2 pt-7 pb-4 mx-auto text-center">
            <div class="text-body-2 mb-4">
              Would you like to generate the report?
            </div>
            <v-btn
              class="ma-1"
              color="error"
              plain
              @click="generateDialog = false"
            >
              Cancel
            </v-btn>
            <v-btn
              class="ma-1"
              color="primary"
              plain
              :loading="loadingGenerateDialog"
              @click="generateAcademicReport(academicInfo)"
            >
              OK
            </v-btn>
          </v-sheet>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="academicDialog"
        :max-width="450"
      >
        <v-card>
          <v-toolbar
            flat
            dark
            color="#78909C"
            dense
            style="height:45px; overflow-y: hidden;"
          >
            Generate Academic Report
          </v-toolbar>
          <v-sheet class="px-4 pt-4 pb-4 mx-auto text-center">
            <v-card 
              class="mx-auto"
              style="margin-bottom: 10px;padding:20px 20px;"
              rounded="lg"
              outlined
            >
              <div
                style="display: flex;flex-wrap: wrap;"
              >
                <v-text-field
                  v-for="(value, key) in academicInfo"
                  :key="key"
                  v-model="academicInfo[key]"
                  :value="value"
                  :label="key"
                  style="margin:5px;width:200px;"
                />
                <v-btn
                  color="#78909C"
                  style="margin: 0px 10px 3px 0px;"
                  outlined
                  block
                  :loading="loadingSaveAcademicInfo"
                  @click="saveAcademicInfo(academicInfo)"
                >
                  <v-icon>
                    mdi-content-save-move
                  </v-icon>
                  <span style="margin-left:5px;">Save Sample Information</span>
                </v-btn>

                <v-btn
                  color="#78909C"
                  style="margin: 0px 10px 3px 0px;"
                  outlined
                  block
                  :disabled="selectedRowData.academicProgress !== 100 && !academicError"
                  @click="eventHandler('generate')"
                >
                  <div v-if="selectedRowData.academicProgress !== 100 && !academicError" style="display:flex;justify-content: flex-start;">
                    <div id="progress-bar-container">
                      <span id="progress-bar" />
                    </div>
                    <span class="blink-text">Generating Report...</span>
                  </div>
                  <div v-else style="display:flex;align-items:center;">
                    <v-icon>
                      mdi-file-chart-outline
                    </v-icon>
                    <span style="margin-left:5px;">Generate Report</span>
                  </div>
                </v-btn>

                <v-btn
                  color="#78909C"
                  style="margin: 0px 10px 3px 0px;"
                  outlined
                  block
                  :disabled="selectedRowData.academicPath === null || academicError"
                  @click="downloadAcademicReport(selectedRowData.academicPath)"
                >
                  <div v-if="academicError" style="display:flex;justify-content: flex-start;">
                    <v-icon color="#B71C1C">
                      mdi-close-circle-outline
                    </v-icon>
                    <span style="margin-left:5px; padding: 5px 0px; color:#B71C1C">Error Interrupted</span>
                  </div>
                  <div v-else style="display:flex;align-items:center;">
                    <v-icon>
                      mdi-file-download
                    </v-icon>
                    <span style="margin-left:5px; padding: 5px 0px;">Download Report</span>
                  </div>
                </v-btn>
              </div>
            </v-card>
          </v-sheet>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import Vue from 'vue'
import 'tui-grid/dist/tui-grid.css'
import { Grid } from '@toast-ui/vue-grid'
import 'tui-date-picker/dist/tui-date-picker.css';
import 'tui-time-picker/dist/tui-time-picker.css';
import 'tui-pagination/dist/tui-pagination.css';
import moment from 'moment';
import io from 'socket.io-client';


var CustomTextOrderNum = function(props) {
  let div = document.createElement("div");
  var el = document.createElement("button");
  if (props.formattedValue == "") {
    el.innerHTML =
    '<span class="v-btn__content" style="margin-left:4px;"></span>';
  } else {
    el.innerHTML =
    `<span class="v-btn__content"><b style="margin-left:4px;color:#1E88E5">${props.value}</b></span>`;
  }

  const { grid, rowKey, columnInfo } = props;
  el.addEventListener("click", () => {});
  el.style.width = "calc(100% - 10px)";
  el.style.margin = "4px 0px 0px 0px";
  div.appendChild(el);

  this.el = div;
  this.render(props);
};

CustomTextOrderNum.prototype.getElement = function() {
  return this.el;
};
CustomTextOrderNum.prototype.getValue = function() {
  return this.el.value;
};
CustomTextOrderNum.prototype.render = function(props) {
  this.el.value = props.value;
};

var CustomText = function(props) {
  let div = document.createElement("div");
  var el = document.createElement("button");
  // const isReply = props.grid.store.data.rawData[props.rowKey].isReply
  if (props.formattedValue == "") {
    el.innerHTML =
    `<span class="v-btn__content"><b style="color:#1E88E5">&nbsp;</b></span>`;
  } else {
    el.innerHTML =
    `<span class="v-btn__content"><b style="color:#1E88E5">&nbsp;${props.value}</b></span>`;
  }

  const { grid, rowKey, columnInfo } = props;
  el.addEventListener("click", () => {});
  el.style.width = "calc(100% - 10px)";
  el.style.margin = "4px 0px 0px 0px";
  div.appendChild(el);

  this.el = div;
  this.render(props);
};

CustomText.prototype.getElement = function() {
  return this.el;
};
CustomText.prototype.getValue = function() {
  return this.el.value;
};
CustomText.prototype.render = function(props) {
  this.el.value = props.value;
};

var CustomButtonReport = function(props) {
  let div = document.createElement("div");
  var el = document.createElement("button");
  const progress = props.grid.store.data.rawData[props.rowKey].progress
  const date = props.grid.store.data.rawData[props.rowKey].createDate
  if (progress !== 100) {
    el.innerHTML =
    '<span class="v-btn__content" style="diplay:flex;justify-content:center;cursor:pointer;"><i aria-hidden="true" class="v-icon notranslate v-icon--left mdi mdi-progress-pencil orange--text text--darken-2 theme--light" style="font-size: 20px;"></i></span>';
    
    let checkError =  moment().diff(moment(date), 'hours') >= 3;
    if (checkError) {
      el.innerHTML =
        '<span class="v-btn__content" style="diplay:flex;justify-content:center;cursor:pointer;"><i aria-hidden="true" class="v-icon notranslate v-icon--left mdi mdi-progress-close red--text text--darken-2 theme--light" style="font-size: 20px;"></i></span>';
    }
  } else {
    el.innerHTML =
    // '<span class="v-btn__content" style="diplay:flex;justify-content:center;margin-left:0.5vw;"><i aria-hidden="true"class="v-icon notranslate v-icon--left mdi mdi-file-upload blue--text text--darken-2 theme--light" style="font-size: 20px;"></i></span>';
    '<span class="v-btn__content" style="diplay:flex;justify-content:center;cursor:pointer;"><i aria-hidden="true"class="v-icon notranslate v-icon--left mdi mdi-share-circle blue--text text--darken-2 theme--light" style="font-size: 20px;"></i></span>';
  }

  const { grid, rowKey, columnInfo } = props;
  el.addEventListener("click", () => {});
  el.style.width = "calc(100% - 10px)";
  el.style.margin = "4px 0px 0px 0px";
  div.appendChild(el);

  this.el = div;
  this.render(props);
};

CustomButtonReport.prototype.getElement = function() {
  return this.el;
};
CustomButtonReport.prototype.getValue = function() {
  return this.el.value;
};
CustomButtonReport.prototype.render = function(props) {
  this.el.value = props.value;
};

var CustomButtonAcademicReport = function(props) {
  let div = document.createElement("div");
  var el = document.createElement("button");
  const path = props.grid.store.data.rawData[props.rowKey].academicPath;
  const progress = props.grid.store.data.rawData[props.rowKey].academicProgress;
  const date = props.grid.store.data.rawData[props.rowKey].academicStartDate;
  
  if (!path) {
    if (progress == '0') {
      el.innerHTML =
      '<span class="v-btn__content" style="diplay:flex;justify-content:center;cursor:pointer;"><i aria-hidden="true" class="v-icon notranslate v-icon--left mdi mdi-progress-pencil orange--text text--darken-2 theme--light" style="font-size: 20px;"></i></span>';
    } else {
      el.innerHTML =
      '<span class="v-btn__content" style="diplay:flex;justify-content:center;cursor:pointer;"><i aria-hidden="true" class="v-icon notranslate v-icon--left mdi mdi-circle-edit-outline bla--text text--darken-2 theme--light" style="font-size: 20px;"></i></span>';
    }
  } 
  else {
    if (progress == '0') {
      el.innerHTML =
      '<span class="v-btn__content" style="diplay:flex;justify-content:center;cursor:pointer;"><i aria-hidden="true" class="v-icon notranslate v-icon--left mdi mdi-progress-pencil orange--text text--darken-2 theme--light" style="font-size: 20px;"></i></span>';
    } else {
      el.innerHTML =
      '<span class="v-btn__content" style="diplay:flex;justify-content:center;cursor:pointer;"><i aria-hidden="true"class="v-icon notranslate v-icon--left mdi mdi-download-circle blue--text text--darken-2 theme--light" style="font-size: 20px;"></i></span>';
    }
  }

  let checkError =  moment().diff(moment(date), 'hours') >= 1;
  
  if (checkError && progress == '0') {
    el.innerHTML =
      '<span class="v-btn__content" style="diplay:flex;justify-content:center;cursor:pointer;"><i aria-hidden="true" class="v-icon notranslate v-icon--left mdi mdi-progress-close red--text text--darken-2 theme--light" style="font-size: 20px;"></i></span>';
  }

  const { grid, rowKey, columnInfo } = props;
  el.addEventListener("click", () => {});
  el.style.width = "calc(100% - 10px)";
  el.style.margin = "4px 0px 0px 0px";
  div.appendChild(el);

  this.el = div;
  this.render(props);
};

CustomButtonAcademicReport.prototype.getElement = function() {
  return this.el;
};
CustomButtonAcademicReport.prototype.getValue = function() {
  return this.el.value;
};
CustomButtonAcademicReport.prototype.render = function(props) {
  this.el.value = props.value;
};

var CustomButtonProgress = function(props) {
  let div = document.createElement("div");
  var el = document.createElement("button");
  const progress = props.grid.store.data.rawData[props.rowKey].progress;
  const createDate = props.grid.store.data.rawData[props.rowKey].createDate;
  if (progress !== 100) {
    let checkError =  moment().diff(moment(createDate), 'hours') >= 3;
    if (checkError) {
      el.innerHTML =
      `<div style="display:flex;justify-content:center;margin-left:-15px;"><span style="display:flex;padding:6px 13px;border-radius:20px;width:120px;height:18px;background-color:rgba(255, 205, 210, 1);color:#8B0000;font-size:14px;font-weight: 500;font-familiy:Roboto,sans-serif;cursor:default;margin-left:22px;margin-bottom:3px;"><div style="display:flex;align-items:center;"><div style="font-size:11px;font-weight:900;margin-right:4px;">✖</div></div><div style="display:flex;align-items:center;textAllCaps="false"">Error Interrupted</div></span></div>`;
    } else {
      el.innerHTML =
      `<div style="display:flex;justify-content:center;margin-left:-15px;"><span style="display:flex;padding:6px 13px;border-radius:20px;width:130px;height:18px;background-color:rgba(255, 224, 178, 0.5);color:#BF360C;font-size:14px;font-weight: 500;font-familiy:Roboto,sans-serif;cursor:default;margin-left:17px;margin-bottom:3px;"><div style="display:flex;align-items:center;"><div style="background-color:#BF360C;width:8px;height:8px;border-radius: 4px;margin-right:5px;"/></div><div style="display:flex;align-items:center;textAllCaps="false"">Processing : ${progress} %</div></span></div>`;
    }
  } else {
    el.innerHTML =
    '<div style="display:flex;justify-content:center;margin-left:-40px;"><span style="display:flex;padding:6px 13px;border-radius:20px;width:85px;height:18px;background-color:rgba(227, 255, 244, 1);color:#1B5E20;font-size:14px;font-weight: 500;font-familiy:Roboto,sans-serif;cursor:default;margin-left:40px;margin-bottom:3px;"><div style="display:flex;align-items:center;"><div style="background-color: green;width:8px;height:8px;border-radius: 4px;margin-right:5px;"/></div><div style="display:flex;align-items:center;textAllCaps="false"">Completed</div></span></div>'
  }

  const { grid, rowKey, columnInfo } = props;
  el.addEventListener("click", () => {});
  el.style.width = "calc(100%)";
  el.style.margin = "4px 0px 0px 0px";
  div.appendChild(el);

  this.el = div;
  this.render(props);
};

CustomButtonProgress.prototype.getElement = function() {
  return this.el;
};
CustomButtonProgress.prototype.getValue = function() {
  return this.el.value;
};
CustomButtonProgress.prototype.render = function(props) {
  this.el.value = props.value;
};


var CustomTextWithPointer = function(props) {
  let div = document.createElement("div");
  var el = document.createElement("button");
  el.innerHTML = `<span class="v-btn__content" style="display:flex;justify-content:center;">${props.value}</span>`;
  el.addEventListener("click", () => {});
  el.style.width = "calc(100% - 10px)";
  // el.style.margin = "4px 0px 0px 0px";
  div.appendChild(el);

  this.el = div;
  this.render(props);
};

CustomTextWithPointer.prototype.getElement = function() {
  return this.el;
};
CustomTextWithPointer.prototype.getValue = function() {
  return this.el.value;
};
CustomTextWithPointer.prototype.render = function(props) {
  this.el.value = props.value;
};


export default {
  components: {
    grid: Grid
  },
  data: () => ({
    runProgress: false,
    transitioning: false,
    wide: false,
    md_out: 6,
    cols_in: 6,
    selectedRowData: [],
    academicInfo: {},
    loadingSaveAcademicInfo: false,
    academicError: false,
    levelHeight: 700,
    page: 1,
    pageCount: 5,
    viewCount: 10,
    length: 1,
    componentKey: 0,
    componentKey2: 0,
    //search toolbar
    searchWord: '',
    selectItem: 'All',
    selectItems: ["All"],
    selectItem2: 'All',
    selectItems2: ["All", "Confirm", "Editing", "Finish"],
    level: 0,
    progress: false,
    selected: [],
    deleteDialog: false,
    academicDialog: false,
    generateDialog: false,
    loadingGenerateDialog: false,
    date: [],
    dateFrom: moment(new Date()).subtract(3, "month").format("YYYY-MM-DD"),
    resetFrom: '',
    dateTo: moment(new Date()).format("YYYY-MM-DD"),
    resetTo: moment(new Date()).format("YYYY-MM-DD"),
    menu: false,
    menu2: false,
    search: '',
    errorMsg: '',
    snackBar: '',
    snackBarMessage: '',
    snackBarVariant: '',
    snackBarColor: '',
    sampleData: [],

    // vuetify
    dialog: false,
    taskInfo: {
      region: '',
      database: '',
      mnd: '',
      mxd: '',
      group: '',
      sampleInfo: '',
      sampleCount: '',
      targetRegion: '',
      variableRegion: '',
    },
  
    headers: [],
    data: [],
    gridProps: {
      bodyHeight: 337,
      columnOptions: {
        resizable: true,
        frozenCount: 2,
      },
      data: [],
      header: {
        height: 60,
        complexColumns: [
          {
            header: 'Group',
            name: 'mergeColumn5',
            childNames: ['group1','group2','group3','group4','group5','group6','group7','group8','group9','group10']
          }
        ]
      },
      columns: [
      ],     
      options: {
        treeColumnOptions: {
          name: 'sampleName',
          useIcon: true,
          useCascadingCheckbox: true,
        },
        rowHeaders: ['rowNum']
      },
    },
    gridProps2: {
      bodyHeight: 578,
      pageOptions: {
        useClient: true,
        perPage: 14
      },
      columnOptions: {
        resizable: true,
      },
      data: [],
      columns: [
        {
          header: 'Analysis Name',
          name: 'analysisName',
          width: 550,
          renderer: {
            type: CustomText
          }
        },
        { 
          header: "Client ID", 
          name: "userId",
          renderer: { 
            type: CustomTextWithPointer 
          },
        },
        { 
          header: "Start", 
          name: "createDate",
          align: 'center',
          formatter: 'DateFormat'
        },
        {
          header: 'Finish',
          name: 'completeDate',
          align: 'center',
          formatter: 'DateFormat'
        },
        {
          header: 'Progress',
          name: 'progress',
          align: 'center',
          formatter: 'ButtonFormat',
          width: 200
        },
        { 
          header: "Analysis Report", 
          name: "report", 
          align: 'center',
          formatter: 'ButtonFormat' 
        }, 
        { 
          header: "Academic Report", 
          name: "academicReport", 
          align: 'center',
          formatter: 'ButtonFormat' 
        }, 
      ],  
      options: {
        rowHeaders: ['checkbox', 'rowNum'],
        treeColumnOptions: {
          name: 'sampleName',
          useIcon: true,
          useCascadingCheckbox: true
        }
      },
      myTheme: {
        name: "myTheme",
        value: {
          row: {
            even: {},
            hover: {
              background: '#EEEEEE'
            }
          },
          cell: {
            normal: {
              background: '#FFFFFF',
            },
            header: {
            },
            rowHeader: {
            },
            editable: {
            },
            selectedHeader: {
            },
            focused: {
              border: '#eeeeee'
            },
            disabled: {
            }
          }
        }
      },
    },
  }),
  computed: {
    dateRangeText () {
      return this.date.join(' ~ ')
    },
  },
  watch: {
    searchWord(newVal, oldVal) {
      if (newVal !== '') this.selectItem = '직접검색'
    },
    selectItem(newVal, oldVal) {
      if (newVal !== '직접검색') {
        if (newVal !== null) {
          this.initialize();
        }
      }
    },
  },
  created() {
  },
  beforeDestroy() {
    // Remove socket listener when leaving the component
    this.removeSocketListener();
  },
  async mounted() {
    // await this.initReload();
    await this.getUserData();
    await this.setColumns();
    await this.initialize();
    await this.getUserList();
    await this.initSocket();
    await this.checkRun();
  },
  methods: {
    checkRun(force) {
      const incompleteItems = this.data.filter(item => item.progress !== 100 || item.academicProgress !== 100);
      if (incompleteItems.length > 0 | force) {
        this.runProgress = true;
      } else {
        this.runProgress = false;
      }
      return;
    },
    initReload() {
      const resultRefresh = localStorage.resultRefresh;
      if (resultRefresh == 'true') {
        localStorage.resultRefresh = 'false';
        location.reload();
      } else {
        localStorage.resultRefresh = 'true';
        
      }
    },
    initSocket() {
      // this.$socket._callbacks['$progress'] = [];
      this.$nextTick(() => {
        Vue.prototype.$socket.on('resultProgress', (msg) => {
          this.receiveProgress('resultProgress', msg);
          this.checkRun();
        });
        Vue.prototype.$socket.on('academicProgress', (msg) => {
          this.receiveProgress('academicProgress', msg);
          this.checkRun();
        });
      })
      return;
    },
    async receiveProgress(type, msg) {
      if (msg.progress == 1) {
        await this.initialize();
        this.checkRun();
      } else {
        const itemToUpdate = this.data.find(item => item.id === msg.resultId);
        
        if (itemToUpdate) {
          if (type == 'resultProgress') {
            itemToUpdate.progress = Number(msg.progress) * 100;
          }
        } else {
          console.log('Item not found:', msg.resultId);
        }
        if (this.$refs.grid2) this.$refs.grid2.invoke("resetData", this.data);
      }      
      return;
    },
    removeSocketListener() {
      // Remove the specific socket listener
      this.$socket.off('resultProgress', this.receiveProgress);
    },
    // sendMessage() {
    //   socket.emit('client_message', 'Hello, server!');
    //   return;      
    // },
    wideSwitch(wide) {
      if (wide) {
        this.md_out = 6;
        this.cols_in = 6;
      } else {
        this.md_out = 12;
        this.cols_in = 2;
      }
      this.transitioning = true;
      setTimeout(() => {
        this.transitioning = false;
      this.componentKey += 1;
      }, 50);
      this.componentKey += 1;
      this.wide = !this.wide;
      return;
    },
    callSnackBar(state, message, color, variant) {
      this.snackBar = state || false;
      this.snackBarMessage = message || 'nothing';
      // this.snackBarColor = color || 'primary';
      // this.snackBarVariant = variant || 'tonal';
      
    },
    refresh() {
      if (this.snackBar) {
        this.snackBar = false;
        setTimeout(() => {
          this.callSnackBar(true, 'The page has been refreshed.')
        }, 500);
      } else {
          this.callSnackBar(true, 'The page has been refreshed.')
      }
    },
    onClickResult(ev) {
      if ( ev.targetType !== "etc" && ev.rowKey !== undefined) {        
        const selectedRowData = this.$refs.grid2.invoke("getData").filter(v => v.rowKey == ev.rowKey)[0];
        this.selectedRowData = selectedRowData;
        this.academicError = moment().diff(moment(selectedRowData.academicStartDate), 'hours') >= 1 && selectedRowData.academicProgress == '0';
        if (selectedRowData.academicInfo) {
          const info = selectedRowData.academicInfo;
          const academicInfoSorted = {
            reportType: info.reportType,
            company: info.company,
            receptionDate: info.receptionDate,
            targetRegion: info.targetRegion,
            requestedRead: info.requestedRead || '20000',
            rarefiedRead: info.rarefiedRead || '20000',
            sequencer: info.sequencer || 'Illumina MiSeq',
            fastqLink: info.fastqLink,
          };
          this.academicInfo = academicInfoSorted;
        } else {
          this.academicInfo = {
            reportType: '16S',
            company: '',
            receptionDate: '',
            targetRegion: '',
            requestedRead: '20000',
            rarefiedRead: '20000',
            sequencer: 'Illumina MiSeq',
            fastqLink: '',
          };
        }
        if (ev.columnName == 'analysisName') {
          if (this.wide) this.wideSwitch(this.wide);
          this.taskDialogHandler(selectedRowData);
        } else if (ev.columnName == 'report') {
          this.report(selectedRowData)
        } else if (ev.columnName == 'academicReport') {
          this.academicReport(selectedRowData)
        } 
        else if (ev.columnName == 'order') {
          this.$router.push({ name: 'Order - detail', params: { id: headerId } });
        } else if (ev.columnName == 'userId') {
          this.selectItem = selectedRowData.userId;
          this.initialize();
        }
      }
    },
    onClickInfo(ev) {
      if ( ev.targetType !== "etc" && ev.rowKey !== undefined) {        
        const selectedRowData = this.$refs.grid.invoke("getData").filter(v => v.rowKey == ev.rowKey)[0];
        if (ev.columnName == 'order' && selectedRowData.order !== null) {
          const sampleOrderNum = this.selectedRowData.sampleOrderNum
          const { headerId } = sampleOrderNum.find(v => v.orderNum == selectedRowData.order)
          this.$router.push({ name: 'Order - detail', params: { id: headerId } });
        }
      }
      return;
    },
    setColumns() {
      const level = this.level
      let columns = this.gridProps2.columns;
      if (level !== 1) {
        this.levelHeight = 780;
        this.gridProps2.bodyHeight += 80;
        columns = columns.filter(v => (v.header !== 'Client ID'));
        columns = columns.filter(v => (v.header !== 'Academic Report'));
        columns[1].width = columns[1].width + 200;
        // this.gridProps2.options.rowHeaders = [];
        // this.componentKey2 += 1;
      }
      for (let i of columns) {
        if (i.formatter == "DateFormat") {
          i["formatter"] = ({ value }) => {
            if (value == null || value == "") {
              return "";
            } else {
              return moment(value).format("YYYY-MM-DD HH:mm");
            };
          };
        }
        if (i.formatter == "ButtonFormat") {
          if (i.name == 'report') {
            i["renderer"] = {
              type: CustomButtonReport
            };
          } else if (i.name == 'academicReport') {
            i["renderer"] = {
              type: CustomButtonAcademicReport
            };
          } else if (i.name == 'progress') {
            i["renderer"] = {
              type: CustomButtonProgress
            };
          }
        };
        i["_attributes"] = {
          disabled: true,
          checkDisabled: true,
          className: {
            row: ["gray"]
          }
        }
      }
      if (this.$refs.grid2 != null) {
        this.$refs.grid2.invoke("setColumns", columns);
      }
      this.gridProps2.columns = columns;
    },
    processingDepth(data) {
      let result = data == 'NaN' ? 20000 : data
      result = Number(result).toLocaleString('ko-KR');
      return result;
    },
    processingDate(date) {
      const time = moment(date).format("YYYY-MM-DD hh:mm");
      const resultTime = time !== 'Invalid date' ? time : ''
      return resultTime;
    },
    changeColumns() {
      if (this.level == 1) {
        let coulumns = this.gridProps2.columns;
        coulumns.splice(1, 0, { text: 'Client ID', value: 'userId', sortable: false },)
        this.gridProps2.columns = coulumns;
      }
    },
    async getUserList() {
      try {
        if (this.level == 1) {
          const result = await this.$axios.get(`${this.$apiHost}/result/userList`);
            if (result.statusText == 'OK') {
              let userList = result.data.userList
              let selectItems = []
              selectItems.push("All")
              for (const i of userList) {
                const item = i.clientId + ' : ' + i.userName + ' : ' + i.company.company_name;
                selectItems.push({ name : item, value : i.clientId})
              }
              this.selectItems = selectItems;
            }
        }
      } catch (error) {
        console.error(error);
      } finally {
        return false;
      }
    },
    getUserData() {
      const token = this.$store.getters.getAccessToken;
      let base64Url = token.split(".")[1];
      let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      let jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function(c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );
      let user = JSON.parse(jsonPayload);
      if (user.level == 1) {
        this.dateFrom = "2022-02-06";
        this.resetFrom = "2022-02-06";
      } else {
        this.dateFrom = moment(user.createDate).format("YYYY-MM-DD");
        this.resetFrom = moment(user.createDate).format("YYYY-MM-DD");
      }
      this.level = user.level;
      return false;
    },
    async removeResult() {
      try {
        const params = this.selected;
        const res = await this.$axios.post(`${this.$apiHost}/result/result`, params);
        if (res.statusText == 'OK') {
          this.initialize();
          this.callSnackBar(true, 'The selected analysis has been deleted successfully.')
          this.selected = [];
        }
      } catch (err) {
        console.error(err);
        this.callSnackBar(true, 'An error occurred on the server. Please contact the server administrator.')
      }
      this.deleteDialog = false;
      return false;
    },
    async initialize() {
      try {
        this.progress = true;
        const date = [this.dateFrom, this.dateTo];
        const searchId = this.selectItem !== '직접검색' ? this.selectItem : this.searchWord
        const params = {
          date,
          analysisName: this.search,
          searchId
        };
        const res = await this.$axios.post(`${this.$apiHost}/result`, params);
        if (res.statusText == 'OK') {
          this.data = res.data.list;
          this.$refs.grid2.invoke("resetData", res.data.list);
        }
			} catch (error) {
        console.error(error);
			} finally {
        this.progress = false;
      }
      return false;
    },
    async report (item) {
      try {
        if (item.progress == '100') {
				  window.open(item.reportPath);
          return false;
        } else {
          let checkError =  moment().diff(moment(item.createDate), 'hours') >= 3;
          if (checkError) {
            this.callSnackBar(true, 'An error occurred during the analysis. Please try again after deletion.');
          } else {
            this.callSnackBar(true, 'The analysis has not been completed yet.');
          }
        }
			} catch (error) {
        console.log(error);
			}
      return false;
    },
    async academicReport (item) {
      try {
        if (item.progress !== 100) {
          this.callSnackBar(true, 'The analysis has not been completed yet.')
          return;
        }
        this.academicDialog = true;
			} catch (error) {
        console.log(error);
			}
      return false;
    },
    async saveAcademicInfo (info) {
      try {
        this.loadingSaveAcademicInfo = true;
        const params = {
          id: this.selectedRowData.id,
          academicInfo: info,
        }
        console.log(info);
        const result = await this.$axios.post(`${this.$apiHost}/result/update`, params);
        if (result.statusText == 'OK') {
          setTimeout(() => {
            this.callSnackBar(true, 'Sample information has been successfully updated.')
            this.loadingSaveAcademicInfo = false;
          }, 500);
          // this.academicDialog = false;
        }
      } catch (error) {
        console.log(error);
        this.callSnackBar(true, 'An error occurred on the server. Please contact the server administrator.')
        this.loadingSaveAcademicInfo = false;
        // this.academicDialog = false;
      }
    },
    async generateAcademicReport (info) {
      try {
        this.loadingGenerateDialog = true;
        const params = {
          id: this.selectedRowData.id,
          academicInfo: info,
        }
        const result = await this.$axios.post(`${this.$apiHost}/result/report`, params);
        if (result.statusText == 'OK') {
          setTimeout(() => {
            this.initialize();
            this.checkRun(true);
            this.callSnackBar(true, 'The generation of the academic report has started.');
            this.academicDialog = false;
            this.generateDialog = false;
            this.loadingGenerateDialog = false;
          }, 500);
        }
      } catch (error) {
        console.log(error);
        this.callSnackBar(true, 'An error occurred on the server. Please contact the server administrator.')
        this.academicDialog = false;
        this.generateDialog = false;
        this.loadingGenerateDialog = false;
      }
    },
    async downloadAcademicReport (path) {
      try {
        const params = {
          filePath: this.selectedRowData.academicPath,
        };
        await this.$axios.get(`${this.$apiHost}/client/download`,{params, responseType: "blob",}).then(res => {
          const link = document.createElement('a')
          let blob = new Blob([res.data], {
            type: res.headers["content-type"],
          });
          link.href = window.URL.createObjectURL(blob);
          link.download = `${this.selectedRowData.analysisName}_16S_Microbiome_Analysis_Report.pdf`;
          link.click();
          this.snackBar = true;
          if (this.selectedRowData.academicProgress == '0') {
            this.snackBarMessage = 'The download of the previously generated report is complete.';
          } else {
            this.snackBarMessage = `The report download is complete.`;
          }
          return false;
        })
      } catch (error) {
        console.log(error);
        this.callSnackBar(true, 'An error occurred on the server. Please contact the server administrator.')
        this.academicDialog = false;
      }
    },
    async taskDialogHandler(row) {
      this.taskInfo = {
        region: row.region,
        database: row.database,
        mnd: row.mnd == '0' ? 'NaN' : row.mnd,
        mxd: row.mxd == '0' ? 'NaN' : row.mxd,
        group: row.group,
        sampleInfo: row.sampleInfo,
        sampleCount: row.sampleCount,
        targetRegion: row.targetRegion,
        variableRegion: row.variableRegion,
        progress: row.progress,
        name: row.analysisName
      };

      let gridData = [];
      let columns = [];
      const sampleOrderNum = row.sampleOrderNum
      let sampleInfo = row.sampleInfo;
      if (sampleInfo) {
        sampleInfo = sampleInfo.split("\n")
        for (const i of sampleInfo) {
          i = i.split("\t")
          const last = i[i.length - 1].split("\r");
          i.pop()
          i.push(last[0])
          if (i[0] == '#SampleID') {
            columns.push({ header : 'Order Num', name : 'order', align: 'left', width: 113, renderer: { type: CustomTextOrderNum } })
            columns.push({ header : 'Sample ID', name : 'SampleID', align: 'left' })
            let complexColumnsChilds = [];
            for (let j = 1; j < i.length; j++) {
              columns.push({ header : i[j], name : `group${j}` })
              complexColumnsChilds.push(`group${j}`);
            }
            this.gridProps.header.complexColumns.childNames = complexColumnsChilds
          } else if (i[0] == '#q2:types') {
            // let data = { 'SampleID' : '#q2:types', }
            // for (let j = 1; j < i.length; j++) {
            //   data[`group${j}`] = i[j];
            // }
            // gridData.push(data);
          } else {
            if (i[0]) {
              const sample = sampleOrderNum?.find(v => v.sampleName == i[0]);
              let data = { 'SampleID' : i[0], 'order' : sample?.orderNum }
              for (let j = 1; j < i.length; j++) {
                data[`group${j}`] = i[j];
              }
              gridData.push(data);
            }
          }
        }
      }
      this.gridProps.columns = columns;
      this.gridProps.data = gridData;
      this.componentKey += 1;
      this.dialog = true;

      return gridData;
    },
    eventHandler(event) {
      if (event == 'delete') {
        const checkedRows = this.$refs.grid2.invoke("getCheckedRows");
        this.selected = checkedRows;
        if (checkedRows.length == 0) {
          this.callSnackBar(true, 'Select the analysis you want to delete.')
        } else {
          this.deleteDialog = true;
        }
      } else if (event == 'generate') {
        this.generateDialog = true;
      }
    }
  },
}
</script>

<style scoped>
.title_box {
  display:flex;
  justify-content:space-between;
}
.chip_box {
  display: flex;
  justify-content: flex-start;
  width: 400px;
  z-index: 100;
}
.chip_box.on {
  display: flex;
  justify-content: flex-start;
  width: 400px;
  z-index: 100;
}
.chip_box2 {
  display: flex;
  justify-content: flex-start;
  margin: -8px 0px;
  flex-wrap: wrap;
}
.chip {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 200px;
}
.chip_title {
  font-weight:500;
  font-size:15px;
  color:#757575;
}
.select_box {
  width:600px;
  margin: 3px 0px -25px 10px !important;
  font-size:15px !important;
}
div p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 360px;
  margin: 0px;
}


#progress-bar-container {
  position: relative;
  width: 36px;
  height: 36px;
}

#progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px solid #eeeeee;
  border-top-color: #2196f3;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.nothing {
  opacity: 1;
  transition: 0.5s ease-in;
}

.nothing.on {
  opacity: 0;
  transition: 0s;
}


#progress-bar-container {
  position: relative;
  width: 24px;
  height: 24px;
}

#progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px solid #757575;
  border-top-color: #2196f3;
  animation: spin 1s linear infinite;
}

.blink-text {
  margin-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: blink 1s infinite;
}

@keyframes blink {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>